"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
require("../sass/app.scss");
var accordian_1 = require("./component/accordian");
var category_links_1 = require("./component/category-links");
var content_set_1 = require("./component/content-set");
var flow_grid_1 = require("./component/flow-grid");
var header_1 = require("./component/header");
var hero_carousel_1 = require("./component/hero-carousel");
var hero_links_1 = require("./component/hero-links");
var image_gallery_1 = require("./component/image-gallery");
var navigation_1 = require("./component/navigation");
var read_more_1 = require("./component/read-more");
var scroll_down_1 = require("./component/scroll-down");
var show_more_1 = require("./component/show-more");
var te_reo_titles_1 = require("./component/te-reo-titles");
var video_list_1 = require("./component/video-list");
var video_modal_1 = require("./component/video-modal");
var accessibility_1 = require("./helper/accessibility");
var _accessibility = new accessibility_1.Accessibility();
if ((0, navigation_1.hasNavigation)()) {
  var _navigation = new navigation_1.Navigation();
}
if ((0, hero_links_1.hasHeroLinks)()) {
  var _heroLinks = new hero_links_1.HeroLinks();
}
if ((0, category_links_1.hasCategoryLinks)()) {
  var _heroLinks2 = new category_links_1.CategoryLinks();
}
if ((0, content_set_1.hasContentSet)()) {
  var _contentSet = new content_set_1.ContentSet();
}
if ((0, video_list_1.hasVideoList)()) {
  var _videoList = new video_list_1.VideoList();
}
if ((0, flow_grid_1.hasGrid)()) {
  var _flowGrid = new flow_grid_1.FlowGrid();
}
if ((0, image_gallery_1.hasGallery)()) {
  var _imageGallery = new image_gallery_1.ImageGallery();
}
if ((0, hero_carousel_1.hasHeroCarousel)()) {
  var _heroCarousel = new hero_carousel_1.HeroCarousel();
}
if ((0, scroll_down_1.hasScrollDown)()) {
  var _scrollDown = new scroll_down_1.ScrollDown();
}
if ((0, header_1.hasHeader)()) {
  var _header = new header_1.Header();
}
if ((0, read_more_1.hasReadMore)()) {
  var _readMore = new read_more_1.ReadMore();
}
if ((0, accordian_1.hasAccordian)()) {
  var _Accordian = new accordian_1.Accordian();
}
if ((0, show_more_1.hasShowMore)()) {
  var _ShowMore = new show_more_1.ShowMore();
}
if ((0, video_modal_1.hasVideoModal)()) {
  var _VideoModal = new video_modal_1.VideoModal();
}
if ((0, te_reo_titles_1.hasTeReoTitles)()) {
  var _TeReoTitles = (0, te_reo_titles_1.TeReoTitles)();
}